<template>
	<div class="detail_body">
    <div class="coll">
      <h2 class="title"><span>基本信息</span></h2>
      <div class="cons">
        <table class="tab_detail">
          <tr>
            <th>供应商编码</th><td>{{sdata.supplierCode}}</td>
            <th>供应商描述</th><td>{{sdata.supplierName}}</td>
          </tr>
          <tr>
            <th>增值税登记号</th><td colspan="3">{{sdata.vatRegiNum}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="coll">
      <h2 class="title"><span>联系信息</span></h2>
      <div class="cons">
        <table class="tab_detail">
          <tr>
            <th>联系人</th><td>{{sdata.contact}}</td>
            <th>联系电话</th><td>{{sdata.telephone}}</td>
          </tr>
          <tr>
            <th>电子邮件</th><td colspan="3">{{sdata.email}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="coll">
      <h2 class="title"><span>地址</span></h2>
      <div class="cons">
        <table class="tab_detail">
          <tr>
            <th>地区</th><td>{{sdata.proviceDesc}} {{sdata.cityDesc}} {{sdata.countyDesc}}</td>
            <th>详细地址</th><td>{{sdata.streetAddress}}</td>
          </tr>
          <tr>
            <th>邮编</th><td>{{sdata.cityZipCode}}</td>
            <th>国家代码</th><td>{{sdata.countryCode}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="coll">
      <h2 class="title"><span>其他信息</span></h2>
      <div class="cons">
        <table class="tab_detail">
          <tr>
            <th>创建人员</th><td>{{sdata.createUserName}}</td>
            <th>更改人员</th><td>{{sdata.modifyUserName}}</td>
          </tr>
          <tr>
            <th>上次更改日期</th><td colspan="3">{{sdata.lastModifyDate}}</td>
          </tr>
        </table>
      </div>
    </div>
	</div>
</template>

<script>
export default{
  props:{
    sdata:Object
  },
	created(){

	},
	methods:{
	}
}
</script>

<style>
</style>
